
<template>
    <div>
        <Modal v-model="modalShow" fullscreen :title="industryNav.title" @on-visible-change="modalClose" :footer-hide="true" :closable="false">
            <p slot="header">
                <span>{{industryNav.title}}</span>
                <Button style="float:right; font-size:12px" type="primary" size="small" @click="modalShow=false">关 闭</Button>
            </p>
            <div class="industryDetail_box" ref="showPdf">
                <Form ref="title" :label-width="100" label-colon="：">
                    <Row>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}">
                            <FormItem label="三级菜单">
                                <div v-html="industryDetail.thirdMenu.thirdMenuName"></div>
                            </FormItem>
                        </Col>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}">
                            <FormItem label="日期">
                                <div v-html="industryDetail.createDate"></div>
                            </FormItem>
                        </Col>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}">
                            <FormItem label="公司">
                                <div v-html="industryDetail.companyName"></div>
                            </FormItem>
                        </Col>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}">
                            <FormItem label="重要性">
                                <Rate v-model="industryDetail.importantFlag" :count="3" disabled />
                                <Button style="float:right" shape="circle" type="primary" size="small" @click="commentModal=true">评论</Button>
                            </FormItem>
                        </Col>
                        <!-- <Col :sm="{ span: 24}" :xl="{ span: 24}">
                            <FormItem label="标题">
                                <div v-html="industryDetail.title"></div>
                            </FormItem>
                        </Col> -->
                        <Col :sm="{ span: 24}" :xl="{ span: 24}">
                            <FormItem label="摘要">
                                <div v-html="industryDetail.description"></div>
                            </FormItem>
                        </Col>
                        <Col :sm="{ span: 24}" :xl="{ span: 24}" v-if="isURL">
                            <FormItem label="链接地址">
                                <Button shape="circle" type="primary" @click="jumpClick(industryDetail.url)">链接原文</Button>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
                <div class="main_content" id="mainContent" ref="mainContent">
                    <Spin size="large" fix v-if="spinShow"></Spin>
                    <Scroll v-if="isPDF" class="text-center" :on-reach-edge="getPDFfile" :height="scrollHeight" :distance-to-edge="-60">
                        <img :src="item" v-for="(item, index) in imgList" :key="index" v-bind:style="{width: contentWidth + 'px'}">
                    </Scroll>
                    <div v-if="isDocx" v-html="wordTxt"></div>
                </div>
                <div ref="comment">
                    <div ref="commentShow" style="background: #DEDEDE">
                        <Scroll :on-reach-bottom="handleReachBottom" :height="height">
                            <Row type="flex" v-for="(item, index) in commentList" :key="index">
                                <Col span="18" v-html="item.comment"></Col>
                                <Col span="1">
                                    <div class="no-centet">
                                        {{index + 1}}
                                    </div>
                                </Col>
                                <Col span="5" class="rate_btn">
                                    <span><Rate :value="item.goodFlag" disabled :count="3" /></span>
                                    <span>{{item.commentDate}} {{item.creator.username}}</span>
                                </Col>
                            </Row>
                        </Scroll>
                    </div>
                </div>
            </div>
        </Modal>
        <Modal v-model="commentModal" title="评论" :footer-hide="true" >
            <Row>
                <Col span="24">
                    <Input v-model="commentValue" placeholder="评论内容" type="textarea" :rows="3"/>
                </Col>
                <Col span="24" class="rate_btn">
                    <div>
                        <Rate v-model="commentRate" :count="3" />
                    </div>
                    <div style="margin-top:5px">
                        <Button type="primary" style="width:80%" @click="addDocComment">保存</Button>
                    </div>
                </Col>
            </Row>
        </Modal>
    </div>
</template>

<script>
// import PDFJS from 'pdfjs-dist';
// import { TextLayerBuilder } from 'pdfjs-dist/web/pdf_viewer';
// import 'pdfjs-dist/web/pdf_viewer.css';

import mammoth from 'mammoth';

import api from '@/api/index';
import { timestampToHM } from '@/assets/js/utils';

export default {
    props: {
        show: { type: Boolean, default: false },
        tData: { type: Object }
    },
    data() {
        return {
            modalShow: this.show,
            industryNav: this.tData,
            scale: 1.2,
            totals: [],
            viewHeight: 0,
            height: 0,
            commentList: [],
            industryDetail: {
                thirdMenu: {}
            },
            isPDF: false,
            isDocx: false,
            isURL: false,
            commentValue: '',
            commentRate: 0,
            wordTxt: '',
            limit: 5,
            pageNum: 1,
            imgList: [],
            spinShow: true,
            commentModal: false,
            contentWidth: 0,
            docIndex: 0,
            scrollHeight: 300
        };
    },
    watch: {
        show(val, oldVal) {
            this.modalShow = val;
            if (this.industryNav.id && val) {
                this.findIndustryDocByID();
                this.findByIndustryDocID();
                this.commentList = [];
            }
        },
        tData(val, oldVal) {
            this.industryNav = val.data;
            if (this.modalShow) {
                this.findIndustryDocByID();
                this.findByIndustryDocID();
                this.commentList = [];
                this.addDocLog();
            }
        }
    },
    mounted() {
        window.onresize = () => {
            // 通过捕获系统的onresize事件触发我们需要执行的事件
            this.getShowContentWidth();
        };
    },
    methods: {
        // 窗口关闭时候触发
        modalClose(val) {
            if (!val) {
                this.$emit('update:show', val);
                this.imgList = [];
                this.industryNav = {};
            }
        },
        // 添加浏览记录
        async addDocLog() {
            await api.addDocLog(this.industryNav.id);
        },
        // 获取详情的数据
        async findIndustryDocByID() {
            this.isURL = false;
            this.isPDF = false;
            this.isDocx = false;
            const res = await api.findIndustryDocByID(this.industryNav.id);
            this.industryDetail = res.data;
            if (res.data.url) {
                this.isURL = true;
            }
            setTimeout(() => { this.getShowContentWidth(); }, 0);
            this.findIndustryDocFileByID();
        },
        // 获取详情的文件
        async findIndustryDocFileByID() {
            if (!this.industryDetail.fileName) {
                this.spinShow = false;
                return;
            }
            let fileType = this.industryDetail.fileName.split('.');
            if (fileType.length < 2) {
                this.spinShow = false;
                return;
            }
            this.spinShow = true;
            fileType = fileType[fileType.length - 1].toLowerCase();
            switch (fileType) {
            case 'pdf':
                this.isPDF = true;
                this.imgList = [];
                this.docIndex = 0;
                this.getPDFfile();
                break;
            case 'docx':
                this.isDocx = true;
                this.getWordfile();
                break;
            // case 'doc':
            //     this.dataURLtoBlob('data:application/msword;base64,' + res.data.split(',')[1]);
            //     break;
            }
        },
        async getPDFfile() {
            const res = await api.findIndustryDocFileByIDWithBase64ImageListForLimit(this.industryNav.id, this.docIndex, this.docIndex + 10);
            this.spinShow = false;
            this.getShowContentWidth();
            this.imgList = this.imgList.concat(res.data);
            this.docIndex += 10;
        },
        // async getPDFfile() {
        //     const res = await api.findIndustryDocFileByIDWithBase64ImageList(this.industryNav.id);
        //     this.spinShow = false;
        //     this.getShowContentWidth();
        //     this.imgList = res.data;
        // },
        async getWordfile() {
            const res = await api.findIndustryDocFileByIDWithBase64(this.industryNav.id);
            this.spinShow = false;
            // this.dataURLtoBlob('data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,' + res.data.split(',')[1]);
            this.dataURLtoBlob(res.data);
        },
        // base64转ArrayBuffer
        dataURLtoBlob(dataurl) {
            alert('123');
            const arr = dataurl.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            const blob = new Blob([u8arr], { type: mime });
            let reader = new FileReader();
            const that = this;
            reader.onload = function(result) {
                mammoth.convertToHtml({ arrayBuffer: result.target.result }).then((result) => {
                    that.wordTxt = result.value;
                });
            };
            reader.readAsArrayBuffer(blob);
        },
        // 获取base64
        // getBase64(file) {
        //     return new Promise((resolve, reject) => {
        //         let reader = new FileReader();
        //         let fileResult = '';
        //         reader.readAsDataURL(file);
        //         // 开始转
        //         reader.onload = function() {
        //             fileResult = reader.result;
        //         };
        //         // 转 失败
        //         reader.onerror = function(error) {
        //             reject(error);
        //         };
        //         // 转 结束  咱就 resolve 出去
        //         reader.onloadend = function() {
        //             resolve(fileResult);
        //         };
        //     });
        // },
        // 获取盒子宽度
        getShowContentWidth() {
            this.contentWidth = parseInt(this.$refs.showPdf.clientWidth - 18);
            this.contentWidth = this.contentWidth > 1000 ? 1000 : this.contentWidth;
            if (this.$refs.PDFBox) {
                this.$refs.PDFBox.style.width = this.contentWidth + 'px';
            }
            const allNum = this.$refs.showPdf.clientHeight - this.$refs.title.$el.clientHeight;
            const reducNum = parseInt(allNum * 0.12);
            this.$refs.comment.style.height = reducNum + 'px';
            this.$refs.mainContent.style.height = (allNum - reducNum) + 'px';
            this.height = reducNum;
            this.scrollHeight = allNum - reducNum;
        },
        // 将PDF内容写入canvas
        renderPdf(pdfUrl) {
            // PDFJS.workerSrc = require('pdfjs-dist/build/pdf.worker.min');
            // PDFJS.GlobalWorkerOptions.workerSrc = '//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.3.200/pdf.worker.js';
            // PDFJS.getDocument(pdfUrl).promise.then(pdf => {
            //     const totalPage = pdf.numPages;
            //     this.createCanvas(totalPage);
            //     for (let i = 1; i <= totalPage; i++) {
            //         pdf.getPage(i).then((page) => {
            //             const pageDiv = document.getElementById(`page-${i}`);
            //             // let viewport = page.getViewport(scale)
            //             const viewportFirst = page.getViewport(1);
            //             // 计算 scale值，this.contentWidth 为 ref = mainContent 的元素的宽度
            //             const scale = this.contentWidth / viewportFirst.width;
            //             const viewport = page.getViewport(scale);
            //             const canvas = document.getElementById('canvas-pdf-' + i);
            //             const context = canvas.getContext('2d');
            //             canvas.height = viewport.height;
            //             canvas.width = viewport.width;
            //             this.viewHeight = viewport.height;
            //             const renderContext = {
            //                 canvasContext: context,
            //                 viewport
            //             };
            //             // page.cleanup();
            //             page.render(renderContext).then((val) => {
            //                 console.log(page);
            //                 return page.getTextContent();
            //             }).then((textContent) => {
            //                 // 创建文本图层div
            //                 const textLayerDiv = document.createElement('div');
            //                 textLayerDiv.setAttribute('class', 'textLayer');
            //                 // 将文本图层div添加至每页pdf的div中
            //                 pageDiv.appendChild(textLayerDiv);
            //                 // 创建新的TextLayerBuilder实例
            //                 const textLayer = new TextLayerBuilder({
            //                     textLayerDiv: textLayerDiv,
            //                     pageIndex: page.pageIndex,
            //                     viewport: viewport
            //                 });
            //                 textLayer.setTextContent(textContent);
            //                 textLayer.render();
            //             });
            //         });
            //     }
            // });
        },
        // 生成canvas
        // createCanvas(totalPages) {
        //     for (let i = 1; i <= totalPages; i++) {
        //         this.totals.push(i);
        //     }
        // },
        // 评论加载
        handleReachBottom(dir) {
            return new Promise(resolve => {
                api.findByIndustryDocID(this.industryNav.id, this.limit, this.pageNum).then(res => {
                    for (let val of res.data.data) {
                        val.commentDate = timestampToHM(val.commentDate);
                        this.commentList.push(val);
                        this.pageNum = this.pageNum + 1;
                        resolve();
                    }
                });
            });
        },
        async findByIndustryDocID() {
            const res = await api.findByIndustryDocID(this.industryNav.id, this.limit, this.pageNum);
            for (let val of res.data.data) {
                val.commentDate = timestampToHM(val.commentDate);
                this.commentList.push(val);
            }
            this.pageNum = this.pageNum + 1;
        },
        // 新建评论
        async addDocComment() {
            if (this.commentValue === '') {
                this.$Message.warning({
                    background: true,
                    content: '请填写评价内容！'
                });
                return;
            }
            const res = await api.addDocComment(this.industryNav.id, this.commentRate, this.commentValue);
            if (res.code !== 200 || res.result !== 'success') {
                this.$Message.warning({
                    background: true,
                    content: '保存失败请重试！'
                });
                return;
            }
            this.commentList.unshift({
                comment: this.commentValue,
                goodFlag: this.commentRate,
                commentDate: timestampToHM(new Date()),
                creator: {
                    username: localStorage.getItem('CMSUserName')
                }
            });
            this.commentValue = '';
            this.commentRate = 0;
            this.commentModal = false;
        },
        jumpClick(url) {
            this.$Modal.confirm({
                title: '提示',
                content: '内部资料，谨慎外传',
                onOk: () => {
                    window.open(url);
                }
            });
        }
    }
};
</script>
<style lang="scss">
    .industryDetail_box {
        overflow: hidden;
        height: 100%;
        .pdf-box {
            position: relative;
            text-align: left;
            display: inline-block;
        }
    }
    .main_content {
        overflow: auto;
        position: relative;
    }
    .rate_btn {
        text-align: center;
    }
    .no-centet {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .comment-box {
        position: relative;
        .comment-detail {
            margin-left: 40px;
            margin-right: 150px;
            height: 100%;
        }
        .comment-no {
            width: 40px;
            float: left;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
        }
        .comment-rate {
            width: 150px;
            float: right;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            height: 100%;
        }
    }
    .w-100 {
        width: 100%;
    }
    .text-center {
        text-align: center;
        display: flex;
        justify-content: center;
    }
</style>
<style scoped>
.industryDetail_box >>> .ivu-form-item {
    margin-bottom: 0px;
}
.industryDetail_box >>> .ivu-form-item-label {
    padding:  5px 12px 5px 0;
}

.industryDetail_box >>> .ivu-form-item-content {
    line-height: 22px;
}
.main_content >>> .ivu-scroll-loader-text, .main_content >>> .ivu-scroll-spinner-icon {
    color: red;
}
</style>
